<template>
  <!-- Stats Panel -->
  <div
    v-if="!loading && hasData"
    class="flex flex-1 bg-gray-900 rounded-lg flex-col divide-y-2 divide-gray-950"
  >
    <div class="px-6 py-4 flex items-center gap-2">
      <h2 class="text-text-secondary flex-1">{{ $t('profile.stats_panel.headshot_pct') }}</h2>
      <h1 class="text-text-primary font-medium text-xl">
        {{ headshotPercentage }}%
      </h1>
    </div>
    <div class="px-6 py-4 flex">
      <h2 class="text-text-secondary flex-1">{{ $t('profile.stats_panel.time_to_kill') }}</h2>
      <h1 class="text-text-primary font-medium text-xl">
        {{ timeToKill }}s
      </h1>
    </div>
    <div class="px-6 py-4 flex">
      <h2 class="text-text-secondary flex-1">{{ $t('profile.stats_panel.crosshair_placement') }}</h2>
      <h1 class="text-text-primary font-medium text-xl">
        {{ crosshairPlacement }}°
      </h1>
    </div>
    <div class="px-6 py-4 flex">
      <h2 class="text-text-secondary flex-1">{{ $t('profile.stats_panel.counter_strafing') }}</h2>
      <h1 class="text-text-primary font-medium text-xl">
        {{ counterStrafing }}%
      </h1>
    </div>
  </div>

  <!-- Stats Panel Loading -->
  <div
    v-else
    class="flex flex-1 bg-gray-900 rounded-lg flex-col divide-y-2 divide-gray-950"
  >
    <div class="px-6 py-4 flex items-center gap-2">
      <div class="h-5 w-20 bg-gray-800 rounded animate-pulse flex-1" />
      <div class="h-6 w-12 bg-gray-800 rounded animate-pulse" />
    </div>
    <div class="px-6 py-4 flex">
      <div class="h-5 w-24 bg-gray-800 rounded animate-pulse flex-1" />
      <div class="h-6 w-16 bg-gray-800 rounded animate-pulse" />
    </div>
    <div class="px-6 py-4 flex">
      <div class="h-5 w-32 bg-gray-800 rounded animate-pulse flex-1" />
      <div class="h-6 w-12 bg-gray-800 rounded animate-pulse" />
    </div>
    <div class="px-6 py-4 flex">
      <div class="h-5 w-28 bg-gray-800 rounded animate-pulse flex-1" />
      <div class="h-6 w-14 bg-gray-800 rounded animate-pulse" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  hasData: {
    type: Boolean,
    default: false,
  },
  headshotPercentage: {
    type: [Number, String],
    default: 0,
  },
  timeToKill: {
    type: [Number, String],
    default: 0,
  },
  crosshairPlacement: {
    type: [Number, String],
    default: 0,
  },
  counterStrafing: {
    type: [Number, String],
    default: 0,
  },
});
</script>
